import React, { useEffect, useMemo, useState } from 'react';
import './ListView.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, Tag } from 'antd';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () =>
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia(query).matches
        : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(mql.matches);

    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
};

const taskTagClass = (tag, type) => {
  if (type === 'priority') return tag === 'High' ? 'status_high' : tag === 'Medium' ? 'status_medium' : 'status_low';
  if (type === 'status') return tag === 'Pending' ? 'status_pending' : tag === 'Completed' ? 'status_completed' : 'status_process';
  return 'status_role';
};

const TaskTag = ({ value, type }) => (
  <span className={`modern_task_tag ${taskTagClass(value, type)}`}>{value || '—'}</span>
);

const Listview = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { user } = useAuth();
  const username = user.user;

  // Presentation-only breakpoints, following Dashboard(3).
  const isCompact = useMediaQuery('(max-width: 760px)');
  const isMedium = useMediaQuery('(max-width: 1100px)');

  const [tasks, setTasks] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [siteName, setSiteName] = useState('');
  const [siteAddress, setSiteAddress] = useState('');
  const [siteMobile, setSiteMobile] = useState('');
  const [siteEmail, setSiteEmail] = useState('');
  const [imageFile, setImageFile] = useState(null);

  const [formData, setFormData] = useState({
    taskDetails: '',
    assignee: '',
    priority: '',
    category: '',
    subCategory: '',
    status: '',
    deadline: '',
    clientName: '',
    siteName: '',
    siteAddress: '',
    siteMobile: '',
    siteEmail: '',
    assignedFrom: '',
    role: '',
    createdAt: '',
  });

  const [users, setUsers] = useState([]);
  const [client, setClient] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'clientName') {
      const selectedClient = client.find((c) => c.clientName === value);

      if (selectedClient) {
        setSiteName(selectedClient.siteName);
        setSiteAddress(selectedClient.siteAddress);
        setSiteMobile(selectedClient.siteMobile);
        setSiteEmail(selectedClient.siteEmail);

        setFormData((prev) => ({
          ...prev,
          siteName: selectedClient.siteName || '',
          siteAddress: selectedClient.siteAddress || '',
          siteMobile: selectedClient.siteMobile || '',
          siteEmail: selectedClient.siteEmail || '',
        }));
      }
    } else if (name === 'assignee') {
      const selectedUser = users.find((item) => item.username === value);

      if (selectedUser) {
        setFormData((prev) => ({
          ...prev,
          assignedFrom: username.username,
          role: selectedUser.role,
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const updatedFormData = {
      ...formData,
      createdAt: currentDate.toISOString(),
    };

    fetch(API_URL + '/taskss', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => console.error('Error sending form data:', error));
  };

  useEffect(() => {
    fetch(API_URL + '/users')
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(API_URL + '/client')
      .then((response) => response.json())
      .then((data) => setClient(data))
      .catch((error) => console.error(error));
  }, []);

  const assigneeData = useMemo(
    () => users.map((item) => item.username),
    [users]
  );

  const clientdata = useMemo(
    () => client.map((item) => item.clientName),
    [client]
  );

  const deleteTask = async (uuId) => {
    try {
      const response = await axios.delete(API_URL + `/tasks/${uuId}`);

      if (response.status === 204) {
        fetchTasks();
      } else {
        console.error('Error deleting task');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTasksDetailsByName = (uuId) => {
    const filteredTasks = tasks.filter((task) => task.uuId === uuId);
    navigate('/ListViewInfo', { state: { taskDetails: filteredTasks[0] } });
  };

  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue = '', sortValue = selectedSort) => {
    let endpoint;

    if (!filterValue && !sortValue) {
      endpoint =
        username.role === 'Admin' || username.role === 'HR'
          ? API_URL + '/tasks/all'
          : API_URL + `/tasks/?assignee=${username.username}`;
    } else if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = `${API_URL}/tasks/?assignee=&filter=${filterValue}&sort=${sortValue}`;
    } else {
      endpoint = `${API_URL}/tasks/?assignee=${username.username}&filter=${filterValue}&sort=${sortValue}`;
    }

    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };

  const openForm = () => setIsFormOpen(true);

  const closeForm = () => {
    setIsFormOpen(false);
    setSiteName('');
    setSiteAddress('');
    setSiteMobile('');
    setSiteEmail('');
    setFormData((prev) => ({
      ...prev,
      taskDetails: '',
      clientName: '',
      assignee: '',
      priority: '',
      category: '',
      subCategory: '',
      status: '',
      deadline: '',
    }));
    setImageFile(null);
  };

  const columns = [
    {
      title: 'Task',
      dataIndex: 'Task',
      key: 'Task',
      width: 70,
      render: (value) => <span className="task_number">{value}</span>,
    },
    {
      title: 'Assignee',
      dataIndex: 'Name',
      key: 'Name',
      render: (value) => <span className="assignee_name">{value || 'Unassigned'}</span>,
    },
    {
      title: 'Priority',
      dataIndex: 'Priority',
      key: 'Priority',
      render: (_, { Priority }) => (
        <div className="tag_group">
          {Priority.map((tag) => {
            const cls =
              tag === 'High'
                ? 'status_high'
                : tag === 'Medium'
                  ? 'status_medium'
                  : 'status_low';

            return (
              <Tag className={`modern_task_tag ${cls}`} key={tag}>
                {tag || '—'}
              </Tag>
            );
          })}
        </div>
      ),
    },
    {
      title: 'Status',
      key: 'Status',
      dataIndex: 'Status',
      render: (_, { Status }) => (
        <div className="tag_group">
          {Status.map((tag) => {
            const cls =
              tag === 'Pending'
                ? 'status_pending'
                : tag === 'Completed'
                  ? 'status_completed'
                  : 'status_process';

            return (
              <Tag className={`modern_task_tag ${cls}`} key={tag}>
                {tag || '—'}
              </Tag>
            );
          })}
        </div>
      ),
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      render: (_, { Role }) => (
        <div className="tag_group">
          {Role.map((tag) => (
            <Tag
              className="modern_task_tag status_role"
              key={tag}
            >
              {tag || '—'}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: 'Deadline',
      dataIndex: 'Deadline',
      key: 'Deadline',
      width: 120,
      render: (value) => <span className="deadline_value">{value || '—'}</span>,
    },
    {
      title: 'Action',
      key: 'action',
      width: 105,
      render: (_, record) => (
        <Space size={5}>
          <button
            type="button"
            className="task_action_button"
            onClick={() => getTasksDetailsByName(record.uuId)}
            aria-label="View or edit task"
          >
            <img src="../assets/pencil.png" alt="" />
          </button>
          <button
            type="button"
            className="task_action_button delete"
            onClick={() => deleteTask(record.uuId)}
            aria-label="Delete task"
          >
            <img src="../assets/trash.png" alt="" />
          </button>
        </Space>
      ),
    },
  ];

  const dataa =
    tasks.length > 0
      ? tasks.map((item, index) => ({
          key: index.toString(),
          uuId: item.uuId,
          Task: index + 1,
          Name: item.assignee || '',
          Priority: [item.priority || ''],
          Status: [item.status || ''],
          Role: [item.role || ''],
          Deadline: item.deadline || '',
        }))
      : [];

  const clearFilters = () => {
    setSearchInput('');
    setSelectedSort('');
    fetchTasks('', '');
  };

  return (
    <div className="listview_app page-shell">
      <SideMenuBar />

      <main className="content">
        <NewHeader />

        <div className="listview_container">
          <section className="tasks_page_heading">
            <div>
              <span className="page_kicker">WORK MANAGEMENT</span>
              <h1>Tasks</h1>
              <p>Manage assignments, deadlines, priorities and team workload.</p>
            </div>

            <div className="view_switcher">
              <Link to="/ListView" className="view_tab active">
                <span>☷</span>
                List
              </Link>
              <Link to="/CardVIew" className="view_tab">
                <span>▦</span>
                Card
              </Link>
            </div>
          </section>

          <section className="task_toolbar">
            <div className="task_search_box">
              <img src="../assets/search.png" alt="" />
              <input
                aria-label="Search tasks"
                placeholder="Search tasks or assignees..."
                value={searchInput}
                onChange={(e) => {
                  const text = e.target.value;
                  setSearchInput(text);
                  fetchTasks(text, selectedSort);
                }}
              />
              {searchInput && (
                <button
                  type="button"
                  className="clear_search_button"
                  onClick={() => {
                    setSearchInput('');
                    fetchTasks('', selectedSort);
                  }}
                  aria-label="Clear search"
                >
                  ×
                </button>
              )}
              <kbd>⌘ K</kbd>
            </div>

            <select
              className="sort_by_ListView"
              value={selectedSort}
              aria-label="Sort tasks"
              onChange={(e) => {
                const value = e.target.value;
                setSelectedSort(value);
                fetchTasks(searchInput, value);
              }}
            >
              <option value="" disabled>Sort by</option>
              <option value="Pending">Pending</option>
              <option value="In-Process">In-Process</option>
              <option value="Complete">Complete</option>
            </select>

            <button type="button" className="clear_filter_btn" onClick={clearFilters}>
              Reset
            </button>

            <button type="button" className="add_task_btn" onClick={openForm}>
              <span>+</span>
              Add task
            </button>
          </section>

          <section className="task_overview_strip">
            <div>
              <strong>{tasks.length}</strong>
              <span>Total visible tasks</span>
            </div>
            <div>
              <strong>{tasks.filter((task) => task.status === 'Completed').length}</strong>
              <span>Completed</span>
            </div>
            <div>
              <strong>{tasks.filter((task) => task.status === 'Pending').length}</strong>
              <span>Pending</span>
            </div>
            <div className="overview_hint">
              <span className="overview_dot" />
              Live workspace data
            </div>
          </section>

          {isFormOpen && (
            <>
              <div className="overlay_ListView" onClick={closeForm} />

              <section
                className="popup-form_ListView"
                role="dialog"
                aria-modal="true"
                aria-labelledby="add-task-title"
              >
                <div className="modal_header_ListView">
                  <div>
                    <span className="page_kicker">WORK MANAGEMENT</span>
                    <h2 id="add-task-title">Create new task</h2>
                    <p>Assign work and capture the site details in one place.</p>
                  </div>

                  <button
                    type="button"
                    className="close_ListView"
                    onClick={closeForm}
                    aria-label="Close add task"
                  >
                    ×
                  </button>
                </div>

                <form className="task_form" onSubmit={handleSubmit}>
                  <div className="form_section">
                    <div className="form_section_heading">
                      <span>01</span>
                      <div>
                        <h3>Task details</h3>
                        <p>Define what needs to be completed.</p>
                      </div>
                    </div>

                    <label className="form_field full_width">
                      <span>Task details</span>
                      <textarea
                        placeholder="Enter task details..."
                        name="taskDetails"
                        value={formData.taskDetails}
                        onChange={handleInputChange}
                        required
                      />
                    </label>
                  </div>

                  <div className="form_section">
                    <div className="form_section_heading">
                      <span>02</span>
                      <div>
                        <h3>Assignment</h3>
                        <p>Set ownership, priority and workflow state.</p>
                      </div>
                    </div>

                    <div className="form_grid">
                      <label className="form_field">
                        <span>Assignee</span>
                        <input
                          list="Names"
                          placeholder="Select or type a name"
                          name="assignee"
                          value={formData.assignee}
                          onChange={handleInputChange}
                          required
                        />
                        <datalist id="Names">
                          {assigneeData.map((assignee, index) => (
                            <option key={index} value={assignee} />
                          ))}
                        </datalist>
                      </label>

                      <label className="form_field">
                        <span>Priority</span>
                        <select
                          name="priority"
                          value={formData.priority}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>Select priority</option>
                          <option>High</option>
                          <option>Medium</option>
                          <option>Low</option>
                        </select>
                      </label>

                      <label className="form_field">
                        <span>Category</span>
                        <select
                          name="category"
                          value={formData.category}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>Select category</option>
                          <option>Service</option>
                          <option>Installation</option>
                          <option>Site Visit</option>
                        </select>
                      </label>

                      <label className="form_field">
                        <span>Sub category</span>
                        <select
                          name="subCategory"
                          value={formData.subCategory}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>Select sub category</option>
                          <option>POP</option>
                          <option>Furniture</option>
                          <option>Lights</option>
                        </select>
                      </label>

                      <label className="form_field">
                        <span>Status</span>
                        <select
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>Select status</option>
                          <option>Pending</option>
                          <option>In-Process</option>
                          <option>Completed</option>
                        </select>
                      </label>

                      <label className="form_field">
                        <span>Deadline</span>
                        <input
                          type="date"
                          name="deadline"
                          value={formData.deadline}
                          onChange={handleInputChange}
                          required
                        />
                      </label>

                      <label className="form_field full_width">
                        <span>Upload document</span>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </label>

                      {imageFile && (
                        <div className="image_preview">
                          <img
                            src={URL.createObjectURL(imageFile)}
                            alt="Selected task document preview"
                          />
                          <span>{imageFile.name}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form_section">
                    <div className="form_section_heading">
                      <span>03</span>
                      <div>
                        <h3>Client & site</h3>
                        <p>Client information is populated from the selected record.</p>
                      </div>
                    </div>

                    <div className="form_grid">
                      <label className="form_field full_width">
                        <span>Client</span>
                        <input
                          list="ClientNames"
                          placeholder="Select or type a client"
                          name="clientName"
                          value={formData.clientName}
                          onChange={handleInputChange}
                          required
                        />
                        <datalist id="ClientNames">
                          {clientdata.map((clientName, index) => (
                            <option key={index} value={clientName} />
                          ))}
                        </datalist>
                      </label>

                      <div className="readonly_field">
                        <span>Site name</span>
                        <strong>{siteName || 'Auto-populated'}</strong>
                      </div>

                      <div className="readonly_field">
                        <span>Phone</span>
                        <strong>{siteMobile || 'Auto-populated'}</strong>
                      </div>

                      <div className="readonly_field">
                        <span>Email</span>
                        <strong>{siteEmail || 'Auto-populated'}</strong>
                      </div>

                      <div className="readonly_field full_width">
                        <span>Address</span>
                        <strong>{siteAddress || 'Auto-populated'}</strong>
                      </div>
                    </div>
                  </div>

                  <div className="form_actions">
                    <button
                      type="button"
                      className="popup_form_cancel_ListView"
                      onClick={closeForm}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="popup_form_addTask_ListView"
                    >
                      Create task
                    </button>
                  </div>
                </form>
              </section>
            </>
          )}

          <section className="tasks_table_panel">
            <div className="table_panel_header">
              <div>
                <span className="page_kicker">TASK DATABASE</span>
                <h2>All tasks</h2>
              </div>
              <span className="table_count">{dataa.length} records</span>
            </div>

            <div className="table_ListView">
              {dataa.length > 0 ? (
                isCompact ? (
                  <div className="task_cards">
                    {dataa.map((row) => (
                      <article className="task_card" key={row.key}>
                        <div className="task_card_head">
                          <span className="task_name">
                            <span className="avatar_chip">
                              {String(row.Name || 'NA')
                                .replace(/\(.*\)/, '')
                                .trim()
                                .split(/[\s._-]+/)
                                .filter(Boolean)
                                .slice(0, 2)
                                .map((part) => part[0])
                                .join('')
                                .toUpperCase() || '?'}
                            </span>
                            <span className="task_name_text">{row.Name || 'Unassigned'}</span>
                          </span>
                          <span className="task_index">{String(row.Task).padStart(2, '0')}</span>
                        </div>

                        <div className="task_card_meta">
                          {(row.Status || []).map((tag) => (
                            <TaskTag key={`status-${tag}`} value={tag} type="status" />
                          ))}
                          {(row.Priority || []).map((tag) => (
                            <TaskTag key={`priority-${tag}`} value={tag} type="priority" />
                          ))}
                          {(row.Role || []).map((tag) => (
                            <TaskTag key={`role-${tag}`} value={tag} type="role" />
                          ))}
                        </div>

                        <div className="task_card_foot">
                          {row.Deadline
                            ? <span className="deadline_value">Due {row.Deadline}</span>
                            : <span className="cell_empty">No deadline</span>}

                          <div className="task_card_actions">
                            <button type="button" className="task_action_button"
                              onClick={() => getTasksDetailsByName(row.uuId)}
                              aria-label="View or edit task">
                              <img src="../assets/pencil.png" alt="" />
                            </button>
                            <button type="button" className="task_action_button delete"
                              onClick={() => deleteTask(row.uuId)}
                              aria-label="Delete task">
                              <img src="../assets/trash.png" alt="" />
                            </button>
                          </div>
                        </div>
                      </article>
                    ))}
                  </div>
                ) : (
                  <Table
                    className="modern_tasks_table"
                    columns={columns}
                    dataSource={dataa}
                    scroll={{ x: isMedium ? 680 : 760, y: 500 }}
                    pagination={false}
                  />
                )
              ) : (
                <div className="empty_tasks">
                  <div className="empty_tasks_icon">✓</div>
                  <h3>No tasks found</h3>
                  <p>Try changing your search or filters, or create a new task.</p>
                  <button type="button" onClick={openForm}>Create a task</button>
                </div>
              )}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Listview;
